import { Flex } from "antd";
import { ColoredTextCell } from "../../../components/CellRenderers/ColoredTextCell/ColoredTextCell";
import {
  OznakaSaKolicinom,
  OznakaSaKolicinomPoAmbalazi,
  OznakaSaKolicinomPoPakovanju,
  OznakaSaKolicinomPoRM,
  OznakaSaKolicinomSerijskiBrojevi,
} from "./periodicReports.types";

export const formatQtyAndValuesExcelCell = (qty: number, values?: string[]) => {
  const hasLength = values?.length;
  return `${qty ?? 0} ${hasLength ? `| ${values?.join(",")}` : ""}`;
};

export const formatOznakaSaKolicinomExcelCell = (
  oznakeSaKolicinom: OznakaSaKolicinom[] | null
) => {
  if (!oznakeSaKolicinom?.length) return "";

  return oznakeSaKolicinom
    .map((oznaka) => `${oznaka.slovnaOznaka ?? ""} - ${oznaka.kolicina ?? ""}`)
    .join(" | ");
};

export const formatOznakaSaKolicinomPoPakovanjuExcelCell = (
  oznakeSaKolicinomPoPakovanju: OznakaSaKolicinomPoPakovanju[] | null
) => {
  if (!oznakeSaKolicinomPoPakovanju?.length) return "";

  return oznakeSaKolicinomPoPakovanju
    .map(
      (oznaka) =>
        `${oznaka.slovnaOznaka ?? ""} - ${oznaka.kolicinaPoPakovanju
          ?.map((k) => `${k.ambalaza ?? ""} - ${k.kolicina ?? ""}`)
          .join(", ")}`
    )
    .join(" | ");
};

export const formatOznakaSaKolicinomPoAmbalaziExcelCell = (
  oznakeSaKolicinomPoPakovanju: OznakaSaKolicinomPoAmbalazi[] | null
) => {
  if (!oznakeSaKolicinomPoPakovanju?.length) return "";

  return oznakeSaKolicinomPoPakovanju
    .map(
      (oznaka) =>
        `${oznaka.slovnaOznaka ?? ""} - ${oznaka.kolicinaPoAmbalazi
          ?.map((k) => `${k.ambalaza ?? ""} - ${k.kolicina ?? ""}`)
          .join(", ")}`
    )
    .join(" | ");
};

export const formatOznakaSaKolicinomPoRMExcelCell = (
  oznakaSaKolicinomPoRM: OznakaSaKolicinomPoRM[] | null,
  valuta: string
) => {
  if (!oznakaSaKolicinomPoRM?.length) return "";

  return oznakaSaKolicinomPoRM
    .map(
      (oznaka) =>
        `${oznaka.slovnaOznaka ?? ""} - ${oznaka.kolicinaPoRM
          ?.map(
            (k) =>
              `${k.robnaMarka ?? ""} - ${k.kolicina ?? ""} - ${
                k.cena?.toLocaleString() ?? ""
              } ${valuta ?? ""}`
          )
          .join(", ")}`
    )
    .join(" | ");
};

export const formatOznakaSaKolicinomSerijskiBrojeviExcelCell = (
  oznakaSaKolicinomSerijskiBrojevi: OznakaSaKolicinomSerijskiBrojevi[] | null
) => {
  if (!oznakaSaKolicinomSerijskiBrojevi?.length) return "";
  return oznakaSaKolicinomSerijskiBrojevi
    .map(
      (oznaka) =>
        `${oznaka.slovnaOznaka ?? ""} - ${oznaka.kolicina ?? ""}${
          oznaka.serijskiBrojevi?.length
            ? ` - ${oznaka.serijskiBrojevi.join(", ")}`
            : ""
        }`
    )
    .join(" | ");
};

export const renderOznakeSaKolicinom = (
  oznakeSaKolicinom: OznakaSaKolicinom[] | null,
  checkForFlag: boolean = false
) => {
  if (!oznakeSaKolicinom) return null;

  return (
    <Flex gap={4} vertical>
      {oznakeSaKolicinom.map((oznakaSaKolicinom, index) => (
        <Flex gap={8} key={index} align="center">
          <strong style={{ fontFamily: "unset" }}>
            {oznakaSaKolicinom.slovnaOznaka}
          </strong>
          <span>-</span>
          {oznakaSaKolicinom.redFlag && checkForFlag ? (
            <ColoredTextCell
              color="red"
              text={oznakaSaKolicinom.kolicina?.toString() ?? ""}
              style={{ fontWeight: "bold" }}
            />
          ) : (
            <span>{oznakaSaKolicinom.kolicina}</span>
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export const renderOznakeSaKolicinomPoPakovanju = (
  oznakeSaKolicinomPoPakovanju: OznakaSaKolicinomPoPakovanju[] | null
) => {
  if (!oznakeSaKolicinomPoPakovanju) return null;

  return (
    <Flex vertical gap={8}>
      {oznakeSaKolicinomPoPakovanju.map((oznaka, index) => (
        <Flex
          key={index}
          gap={12}
          style={{
            borderBottom:
              index === oznakeSaKolicinomPoPakovanju.length - 1
                ? "none"
                : "1px solid #BEBEBE",
          }}
        >
          <strong>{oznaka.slovnaOznaka}</strong>
          <span>-</span>
          <Flex vertical gap={4} style={{ flex: 1 }}>
            {oznaka.kolicinaPoPakovanju?.map((kolicina, index) => (
              <Flex key={index} gap={8} align="center">
                <strong style={{ color: "#1890ff" }}>
                  {kolicina.ambalaza}
                </strong>
                <span>-</span>
                <span>{kolicina.kolicina}</span>
              </Flex>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export const renderOznakeSaKolicinomPoAmbalazi = (
  oznakeSaKolicinomPoPakovanju: OznakaSaKolicinomPoAmbalazi[] | null
) => {
  if (!oznakeSaKolicinomPoPakovanju) return null;

  return (
    <Flex vertical gap={8}>
      {oznakeSaKolicinomPoPakovanju.map((oznaka, index) => (
        <Flex
          key={index}
          gap={12}
          style={{
            borderBottom:
              index === oznakeSaKolicinomPoPakovanju.length - 1
                ? "none"
                : "1px solid #BEBEBE",
          }}
        >
          <strong style={{ fontFamily: "unset" }}>{oznaka.slovnaOznaka}</strong>
          <span>-</span>
          <Flex vertical gap={4} style={{ flex: 1 }}>
            {oznaka.kolicinaPoAmbalazi?.map((kolicina, index) => (
              <Flex key={index} gap={8} align="center">
                <strong style={{ color: "#1890ff", fontFamily: "unset" }}>
                  {kolicina.ambalaza}
                </strong>
                <span>-</span>
                <span style={{ fontFamily: "unset" }}>{kolicina.kolicina}</span>
              </Flex>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export const renderOznakaSaKolicinomSerijskiBrojevi = (
  oznakaSaKolicinomSerijskiBrojevi: OznakaSaKolicinomSerijskiBrojevi[] | null
) => {
  if (!oznakaSaKolicinomSerijskiBrojevi) return null;

  return (
    <Flex vertical gap={8}>
      {oznakaSaKolicinomSerijskiBrojevi.map((oznaka, index) => (
        <Flex
          key={index}
          gap={8}
          align="start"
          style={{
            borderBottom:
              index === oznakaSaKolicinomSerijskiBrojevi.length - 1
                ? "none"
                : "1px solid #BEBEBE",
          }}
        >
          <strong style={{ fontFamily: "unset" }}>{oznaka.slovnaOznaka}</strong>
          <span>-</span>
          <span style={{ fontFamily: "unset" }}>{oznaka.kolicina}</span>
          {(oznaka.serijskiBrojevi?.length ?? 0) > 0 && <span>-</span>}
          <Flex vertical gap={4} style={{ flex: 1 }}>
            {oznaka.serijskiBrojevi?.map((serijskiBroj, index) => (
              <span key={index} style={{ fontFamily: "unset" }}>
                {serijskiBroj}
              </span>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export const renderOznakaSaKolicinomPoRM = (
  oznakaSaKolicinomPoRM: OznakaSaKolicinomPoRM[] | null,
  valuta: string
) => {
  if (!oznakaSaKolicinomPoRM) return null;

  return (
    <Flex vertical gap={8}>
      {oznakaSaKolicinomPoRM.map((oznaka, index) => (
        <Flex
          key={index}
          gap={12}
          style={{
            borderBottom:
              index === oznakaSaKolicinomPoRM.length - 1
                ? "none"
                : "1px solid #BEBEBE",
            paddingBottom: 8,
          }}
        >
          <strong style={{ fontFamily: "unset" }}>{oznaka.slovnaOznaka}</strong>
          <span>-</span>
          <Flex vertical gap={8}>
            {oznaka.kolicinaPoRM?.map((kolicina, index) => (
              <Flex key={index} gap={12}>
                <strong
                  style={{ color: "#1890ff", flex: 1, fontFamily: "unset" }}
                >
                  {kolicina.robnaMarka}
                </strong>
                <span>-</span>
                <span style={{ fontFamily: "unset" }}>
                  {kolicina.kolicina?.toLocaleString()}
                </span>
                <span>-</span>
                <i>
                  {kolicina.cena?.toLocaleString()} {valuta}
                </i>
              </Flex>
            ))}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
